import React, { Fragment, useEffect, useState, useRef } from "react";
import {
  Container,
  Card,
  CardTitle,
  Button,
  Row,
  Col,
  FormGroup,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import Invoice from "../functions/Invoice";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import {
  convertToUSDateTimeFormat,
  getCurrentAgencyId,
  getAlertToast,
} from "../../../utils/functions/CustomFunctions";
import {
  LIST_COUPONS_URL,
  DELETE_COUPONS_URL,
} from "../../../utils/APIEndpoints";
import { AGENCY_COUPONS_NEW_PAGE } from "../../../utils/AppRoutes";
import { debounce } from "underscore";
import Pagination from "../../common/Pagination";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";

function Coupons() {
  const [loading, setLoading] = useState(false);
  const [array, setArray] = useState([]);
  //filter state
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filter, setFilter] = useState({
    couponCode: "",
    count: 10,
    // agencyId: '',
  });
  //pagination state
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [dropdownOpen, setdropdownOpen] = useState(false);

  //table Headers
  const tableColumns = [
    { title: "Coupon Code" },
    { title: "User Count" },
    { title: "Discount Percentage" },
    { title: "CreatedDate" },
    { title: "Actions" },
  ];

  const headers = [
    { label: "Coupon Code", key: "couponCode" },
    { label: "User Count", key: "userCount" },
    { label: "Discount Percentage", key: "discountPercentage" },
    { label: "CreatedDate", key: "createdDate" },
  ];

  //handleReset
  const handleReset = () => {
    setFilter((val) => ({
      ...val,
      couponCode: "",
      // agencyId: '',
    }));
  };

  //filter
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter((val) => ({ ...val, [name]: value }));
  };

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        listCoupons({
          ...filter,
          offset: currentPage,
          agencyId: getCurrentAgencyId(),
        }),
      500
    )
  ).current;

  //onPageChanged
  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    listCoupons({
      ...filter,
      offset: page - 1,
      agencyId: getCurrentAgencyId(),
    });
  };

  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };

  const getDownloadFileName = () => {
    return "Coupons-" + convertToUSDateTimeFormat(new Date());
  };

  const handleRowPerPage = ({ target: { name, value } }) => {
    setCurrentPage(0);
    setFilter((val) => ({ ...val, [name]: value || undefined }));
  };

  //Download PDF
  const downloadPdf = () => {
    const doc = new jsPDF("P", "px", "a4");
    doc.autoTable({
      didDrawPage: function (data) {
        doc.text(`Customer - ${convertToUSDateTimeFormat(new Date())}`, 15, 15);
      },
      body: array,
      columns: [
        { header: "Coupon Code", dataKey: "couponCode" },
        { header: "User Count", dataKey: "userCount" },
        { header: "Discount Percentage", dataKey: "discountPercentage" },
        { header: "CreatedDate", dataKey: "createdDate" },
      ],
      margin: {
        top: 30,
        right: 8,
        bottom: 15,
        left: 8,
      },
      rowPageBreak: "avoid",
      theme: "grid",
    });
    doc.save(getDownloadFileName() + ".pdf");
  };

  //get Coupons
  const listCoupons = async (query) => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: LIST_COUPONS_URL,
        headers: authHeader(),
        params: query,
      };
      const response = await API(options);
     
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setTotalRecords(totalCount);
        setArray(data);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  //Delete customer
  const deleteCoupons = async (id) => {
    try {
      // setLoading(true);
      const options = {
        method: "DELETE",
        url: DELETE_COUPONS_URL,
        headers: authHeader(),
        params: { couponId: parseInt(id) },
      };
      const response = await API(options);

      const { status, message } = response.data;
     
      if (status === "Success") {
        listCoupons({
          ...filter,
          offset: currentPage,
          agencyId: getCurrentAgencyId(),
        });
        Swal.fire(getAlertToast("success", message));
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  const {
    couponCode = "",
    // agencyId = '',
  } = filter;

  return (
    <Fragment>
      <Container fluid className="mt-5">
        <Card body>
          <div>
            <CardTitle className="mb-4 f-l w-fit">Coupons</CardTitle>
            <i
              className="fas fa-filter"
              style={{
                float: "right",
                margin: "10px 7px 3px 16px",
                fontSize: "19px",
                cursor: "pointer",
              }}
              onClick={filterToggle}
            ></i>

            <div className="top-btn" style={{ float: "right" }}>
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle color="danger" className="f-r" caret>
                  Export
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={downloadPdf}>PDF</DropdownItem>
                  <DropdownItem>
                    <CSVLink
                    className="link"
                      key={`csv_${array.length}`}
                      data={array}
                      headers={headers}
                      filename={`${getDownloadFileName()}.csv`}
                      target="_blank"
                    >
                      CSV
                    </CSVLink>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>

            <Link to={AGENCY_COUPONS_NEW_PAGE}>
              <Button className="f-r" color="primary">
                New
              </Button>
            </Link>
          </div>

          {isFilterOpen && (
            <Row form className="mb-4" style={{ marginTop: "1rem" }}>
              <Col md={3}>
                <FormGroup>
                  <Input
                    type="text"
                    name="couponCode"
                    placeholder="Coupon Code"
                    onChange={changeFilterField}
                    value={couponCode}
                  />
                </FormGroup>
              </Col>

              {/* <Col md={3}>
                  <FormGroup>
                    <Input
                      type="number"
                      name="agencyId"
                      placeholder="AgencyId"
                      onChange={changeFilterField}
                      value={agencyId}
                    />
                  </FormGroup>
                </Col> */}
              <Col md={2}>
                <div style={{ marginTop: "4px" }}>
                  <Button color="danger" onClick={handleReset}>
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          )}

          <Invoice
            tableColumns={tableColumns}
            listData={array}
            loading={loading}
            deleteCoupons={deleteCoupons}
          />

          {array.length ? (
            <div className="d-flex py-4 justify-content-end space_between">
              <div className="space_between">
                <div>
                  <p className="per_page">Records/Page</p>
                </div>
                <div>
                  <FormGroup>
                    <Input
                      className="pagi_drop"
                      type="select"
                      name="count"
                      onChange={handleRowPerPage}
                      value={filter.count}
                    >
                      <option value={""}>Show All</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </Input>
                  </FormGroup>
                </div>
              </div>
              {filter.count && (
                <div>
                  <Pagination
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={currentPage + 1}
                    itemsCountPerPage={filter.count}
                    totalItemsCount={totalRecords}
                    onChange={onPageChanged}
                  />
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </Card>
      </Container>
    </Fragment>
  );
}

export default Coupons;
